import { Module } from 'vuex';
import { StateInterface } from '@/store';
import state, { LoginStateInterface } from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const loginStateModule: Module<LoginStateInterface, StateInterface> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default loginStateModule;
